// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oRn8","delete":"styles_delete__3PaZv","update":"styles_update__2NChj","add":"styles_add__QIvBq"};